import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchContact, updateContact } from "actions/contact";
import {
  uploadImage,
  setUploadedImagePreview,
  removeUploadedImage
} from "actions/image";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "../Form";

class ContactEdit extends Component {
  componentWillUnmount() {
    this.props.removeUploadedImage("cover");
    this.props.removeUploadedImage("logo");
  }

  componentDidMount() {
    const { activeCompany, match, fetchContact } = this.props;
    const company_url = activeCompany.url;
    const id = match.params.contactId;
    fetchContact(id, { company_url });
  }

  shapedDefaultValuesStructure() {
    return this.props.contact.data;
  }

  updateContact(id, data) {
    const {
      toggleNotification,
      activeCompany,
      toggleFullPageSpinner,
      updateContact,
      history
    } = this.props;

    toggleFullPageSpinner(true);

    updateContact(id, data)
      .then(() => {
        toggleNotification(true, {
          message: "Updated Contact Success",
          infoClassName: "is-success"
        });
        history.push(`/${activeCompany.url}/contacts`);
      })
      .catch(e => {
        toggleNotification(true, {
          message: e.message,
          infoClassName: "is-danger"
        });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  handleFormSubmit = data => {
    const { activeCompany, match } = this.props;
    const id = match.params.contactId;

    data = Object.assign({}, data, { company_url: activeCompany.url });
    this.updateContact(id, data);
  };

  render() {
    const {
      uploadedImagesPreview,
      uploadedImagesPercentage,
      uploadedImages,
      removeUploadedImage,
      uploadImage,
      setUploadedImagePreview,
      contact
    } = this.props;

    if (contact.loading) {
      return "loading";
    }
    const defaultValues = this.shapedDefaultValuesStructure();
    return (
      <Form
        handleFormSubmit={this.handleFormSubmit}
        uploadImage={uploadImage}
        uploadedImages={uploadedImages}
        setUploadedImagePreview={setUploadedImagePreview}
        removeUploadedImage={removeUploadedImage}
        uploadedImagesPreview={uploadedImagesPreview}
        uploadedImagesPercentage={uploadedImagesPercentage}
        defaultValues={defaultValues}
      />
    );
  }
}

const mapStateToProps = ({
  uploadedImages,
  uploadedImagesPercentage,
  uploadedImagesPreview,
  contact
}) => ({
  uploadedImages,
  uploadedImagesPercentage,
  uploadedImagesPreview,
  contact
});

export default connect(mapStateToProps, {
  fetchContact,
  updateContact,
  uploadImage,
  removeUploadedImage,
  setUploadedImagePreview,
  toggleFullPageSpinner,
  toggleNotification
})(ContactEdit);
